import { App } from '@capacitor/app'
import type { NativeAppInfo } from '@/interfaces'
import { reportError } from './error-reporter'
import { isNativeApp } from './native-platform'

let cachedResult: Promise<NativeAppInfo | undefined> | undefined

async function fetchNativeAppInfo(): Promise<NativeAppInfo | undefined> {
  try {
    const { build, version } = await App.getInfo()
    return { versionCode: build, versionName: version }
  } catch (error) {
    reportError(error, { context: 'getNativeAppInfo' })
    return undefined
  }
}

export function formatNativeAppVersion({
  versionName,
  versionCode
}: NativeAppInfo): string {
  return `${versionName} (${versionCode})`
}

export function getNativeAppInfo(): Promise<NativeAppInfo | undefined> {
  if (!isNativeApp()) return Promise.resolve(undefined)

  cachedResult ??= fetchNativeAppInfo()
  return cachedResult
}

// Test-only: the memoization above is module-level state, which otherwise
// leaks between tests in the same file.
export function resetNativeAppInfoCache() {
  cachedResult = undefined
}
